import './index.css'
import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from './App'
import DevGate from './components/DevGate'
import { ThemeProvider } from './context/ThemeContext'

Sentry.init({
  dsn: 'https://a77521701276b8ed621ec4ce46a2d225@o4511262787436544.ingest.de.sentry.io/4511262790778960',
  environment: 'production',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // Don't mask text — makes replays actually readable for debugging.
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Capture 10 % of page loads for performance traces.
  tracesSampleRate: 0.1,
  // Always record a replay when an error occurs.
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0,
})

// createBrowserRouter (Data Router) is required for useBlocker to work.
// App still declares all routes internally using <Routes>.
const router = createBrowserRouter([{ path: '*', element: <App /> }])

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <DevGate>
        <RouterProvider router={router} />
      </DevGate>
    </ThemeProvider>
  </StrictMode>,
)
